<template>
	<div class="row lists__boxes-row--margin">
		<div class="col-lg-4 col-md-4 col-12 lists__boxes-box-wrapper lists__boxes-box--padding">
			<a class="lists__boxes-box-link" :href="kadraGlobal.Url+'/single-my-lists?id=favorites'">
				<div class="lists__boxes-box">
					<div class="lists__boxes-box-top">
						<span class="lists__boxes-box-top-title">Favorites</span>
						<span class="lists__boxes-box-top-link">View list</span>
					</div>
					<div class="lists__boxes-box-bottom">
						<span class="lists__boxes-box-bottom-num-items" v-if="favorites.count === 1" :class="{'lists__boxes-box-bottom-num-items--has-item': favorites.count > 0, '': favorites.count === 0}" v-html="favorites.count+' item'"></span>
						<span class="lists__boxes-box-bottom-num-items" v-else :class="{'lists__boxes-box-bottom-num-items--has-item': favorites.count > 0, '': favorites.count === 0}" v-html="favorites.count+' items'"></span>
						<span class="lists__boxes-box-bottom-last-edited"></span>
					</div>
				</div>
			</a>
		</div>
		<div class="col-lg-4 col-md-4 col-12 lists__boxes-box-wrapper lists__boxes-box--padding">
			<a class="lists__boxes-box-link" :href="kadraGlobal.Url+'/single-my-lists?id=recommendations'">
				<div class="lists__boxes-box">
					<div class="lists__boxes-box-top">
						<span class="lists__boxes-box-top-title">My Recommendations</span>
						<span class="lists__boxes-box-top-link">View list</span>
					</div>
					<div class="lists__boxes-box-bottom">
						<span class="lists__boxes-box-bottom-num-items" v-if="recommendations.length === 1" :class="{'lists__boxes-box-bottom-num-items--has-item': recommendations.length > 0, '': recommendations.length === 0}" v-html="recommendations.length+' item'"></span>
						<span class="lists__boxes-box-bottom-num-items" v-else :class="{'lists__boxes-box-bottom-num-items--has-item': recommendations.length > 0, '': recommendations.length === 0}" v-html="recommendations.length+' items'"></span>

						<span class="lists__boxes-box-bottom-last-edited"></span>
					</div>
				</div>
			</a>
		</div>
		<div class="col-lg-4 col-md-4 col-12 lists__boxes-box-wrapper lists__boxes-box--padding">
			<a class="lists__boxes-box-link" :href="kadraGlobal.Url+'/single-my-lists?id=viewed'">
				<div class="lists__boxes-box">
					<div class="lists__boxes-box-top">
						<span class="lists__boxes-box-top-title">Recently Viewed</span>
						<span class="lists__boxes-box-top-link">View list</span>
					</div>
					<div class="lists__boxes-box-bottom">
						<span class="lists__boxes-box-bottom-num-items" v-if="viewed.length === 1" :class="{'lists__boxes-box-bottom-num-items--has-item': viewed.length > 0, '': viewed.length === 0}" v-html="viewed.length+' item'"></span>
						<span class="lists__boxes-box-bottom-num-items" v-else :class="{'lists__boxes-box-bottom-num-items--has-item': viewed.length > 0, '': viewed.length === 0}" v-html="viewed.length+' items'"></span>
						<span class="lists__boxes-box-bottom-last-edited"></span>
					</div>
				</div>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	props: ['favorites', 'kadraGlobal', 'recommendations', 'viewed'],
};
</script>

<style lang="scss" scoped></style>
